import React from "react"

import { DialogM } from "@common/components/alert/dialog/Dialog"
import { theme } from "@common/theme/theme"
import GenerateActivityModal from "../students/GenerateActivityModal"

/**
 * 🔄 « Recommencer » sur la carte élève → GenerateActivityModal réduit au
 * formulaire (pas de zone OCR, pas d'ancienne interface), routé vers
 * l'endpoint regenerate de Sam via `onSubmitOverride`. Le geste vit sur la
 * carte, pas dans l'aperçu (retour de Wajih).
 */
const RegenerateModal = ({
    target,
    draftsByStudentId,
    tutorStudentsById,
    schoolSubjects,
    navigation,
    onClose,
    onConfirm,
}) => {
    if (!target) return null

    const targetDraft = draftsByStudentId[target.student_id]
    // Le cadrage appartient au brouillon, pas à sa première ligne : le tuteur
    // peut retirer celle-ci sans que le formulaire change de chapitre.
    const scope = targetDraft?.scope ?? {}

    // A student under a revision program must get the program's chapter
    // picker: GenerateActivityModal decides that from
    // `student.has_study_program`, which only StudentResource carries.
    // Hand-building a minimal student here dropped the flag, so
    // "Recommencer" always opened in manual mode — even for a student on a
    // program. Pass the real student instead.
    const tutorStudent = tutorStudentsById?.[target.student_id]
    const studentForModal = tutorStudent?.has_study_program
        ? tutorStudent
        : {
              id: target.student_id,
              firstname: target.firstname,
              display_name: target.display_name,
              avatar: target.avatar,
              profile: {
                  class: tutorStudent?.profile?.class ?? scope.class ?? null,
              },
              // Seeds the subject dropdown from what Sam picked.
              activities: scope.school_subject_id
                  ? [{ school_subject_id: scope.school_subject_id }]
                  : [],
          }

    const handleSubmit = (compact) => {
        // Générer ne complète pas la liste : elle la remplace. Ailleurs dans
        // l'appli, « Générer » propose trois exercices au choix, donc le
        // tuteur ne s'attend pas à perdre ce qu'il a déjà ajouté (retour de
        // Wajih). On l'annonce avant d'agir. Le brouillon est la seule source
        // de vérité : ce qu'on annonce ici est exactement ce que le tuteur
        // voit dans « À ajouter ».
        const aRemplacer = targetDraft?.activities?.length ?? 0
        if (aRemplacer > 1) {
            DialogM.show({
                text1: "Remplacer les exercices proposés ?",
                text2: `Les ${aRemplacer} exercices de « À ajouter » seront remplacés par une nouvelle proposition. Ses exercices déjà à faire ne bougent pas.`,
                buttonText1: "Remplacer",
                buttonColor1: theme.colors.warning,
                onPress: () => onConfirm(compact),
                buttonText3: "Annuler",
                onPress3: () => {},
                exitButton: true,
                onPressBack: () => {},
            })
            return
        }

        onConfirm(compact)
    }

    return (
        <GenerateActivityModal
            isOpen
            onClose={onClose}
            student={studentForModal}
            schoolSubjects={schoolSubjects}
            nav={navigation}
            initialChapterId={scope.chapter_id ?? null}
            onSubmitOverride={handleSubmit}
        />
    )
}

export default RegenerateModal
